<template>
  <v-app>
    <NavBar v-if="isTokenExists"></NavBar>
    <v-main :class="{ 'fullscreen-view': $route.name === 'Login' }">
      <div v-if="$route.name !== 'Login'" class="mainContainer">
        <TopPanel v-if="showTopPanel" class="topPanel" />

        <div class="mainArea">
          <div class="layoutWithSubmenu">
            <SubMenu v-if="showSubmenu" class="submenu"></SubMenu>
            <div class="contentArea">
              <PageTitle :title="currentPageTitle" />
              <router-view class="routerView"></router-view>
            </div>
          </div>
        </div>
      </div>
      <router-view v-else class="routerView fullscreen-router-view" />
      <Notification></Notification>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from '@/components/layout/NavBar.vue';
import SubMenu from '@/components/layout/SubMenu.vue';
import Notification from '@/components/common/Notification.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import TopPanel from '@/components/layout/TopPanel.vue';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    NavBar,
    SubMenu,
    Notification,
    PageTitle,
    TopPanel,
  },
  data: () => ({
    schemeList: [],

    //tokenUrl: process.env.VUE_APP_TOKEN,
    refreshTokenTimer: null,
  }),
  created: function () {
    var token = this.$store.getters.refreshToken;
    if (!token) this.$router.push({ name: 'Login', path: '/login' });
    else {
      this.$store.commit('setAuthToken', '');
      this.refreshToken(true);
    }
  },
  computed: {
    tokenBaseUrl(){
      return this.$config.VUE_APP_BASE_URL;
    },
    currentPageTitle() {
      const menu = this.$store.getters.menu;
      const routePath = this.$route.path;

      function findInMenu(items, path) {
        for (const item of items) {
          if (item.to === path) return item;
          if (item.items && item.items.length) {
            const found = findInMenu(item.items, path);
            if (found) return found;
          }
        }
        return null;
      }

      const page = findInMenu(menu, routePath);
      return page ? page.title : '';
    },
    loginData() {
      return this.$store.getters.loginData;
    },
    logoutFlag() {
      return this.$store.getters.logout;
    },
    tfaCode() {
      return this.$store.getters.tfaCode;
    },
    isLarge() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    isTokenExists() {
      if (this.$store.getters.token) return true;

      return false;
    },
    showTopPanel() {
      if (
        this.$route.name == 'BasicData' ||
        this.$route.name == 'Beneficiaries' ||
        this.$route.name == 'BenefitEvents' ||
        this.$route.name == 'Salary' ||
        this.$route.name == 'TransfersIn' ||
        this.$route.name == 'Service' ||
        this.$route.name == 'ExitDeferred' ||
        this.$route.name == 'TransferOut' ||
        this.$route.name == 'Retirement' ||
        this.$route.name == 'Death' ||
        this.$route.name == 'Profiles' ||
        this.$route.name == 'Transactions' ||
        this.$route.name == 'Switches' ||
        this.$route.name == 'InvestMatrix' ||
        this.$route.name == 'Lifestyle' ||
        this.$route.name == 'MemberSummary' ||
        this.$route.name == 'InvestSummary' ||
        this.$route.name == 'TaxProtection' ||
        this.$route.name == 'MemberNotes' ||
        this.$route.name == 'ReportsList' ||
        this.$route.name == 'ReportWriter' ||
        this.$route.name == 'Calculations' ||
        this.$route.name == 'Picklists' ||
        this.$route.name == 'MemberDocuments'
      )
        return true;

      return false;
    },
    showSubNavBarBtn() {
      if (
        this.$route.name == 'BasicData' ||
        this.$route.name == 'MemberDetails' ||
        this.$route.name == 'Beneficiaries' ||
        this.$route.name == 'Salary' ||
        this.$route.name == 'TransfersIn' ||
        this.$route.name == 'Service' ||
        this.$route.name == 'ExitDeferred' ||
        this.$route.name == 'TransferOut' ||
        this.$route.name == 'Retirement' ||
        this.$route.name == 'Death' ||
        this.$route.name == 'Profiles' ||
        this.$route.name == 'Transactions' ||
        this.$route.name == 'Switches' ||
        this.$route.name == 'TaxProtection' ||
        this.$route.name == 'MemberNotes' ||
        this.$route.name == 'MemberDocuments'
      )
        return true;
      return false;
    },
    showSubmenu() {
      if (
        this.$route.name == 'Login' ||
        this.$route.name == 'Account'
        //this.$route.name == 'MemberSearch'
        //this.$route.name == 'SearchResult'
      )
        return false;

      return true;
    },
  },
  watch: {
    loginData(newVal) {
      if (newVal) this.login(newVal.userName, newVal.password);
    },
    logoutFlag() {
      this.logOut();
    },
    tfaCode(newVal) {
      if (newVal) this.verifyTfaCode(newVal);
    },
  },
  methods: {
    login(username, password) {
      const that = this;
      axios({
        method: 'post',
        url: `${this.tokenBaseUrl}/Token/Login`,
        data: { userName: username, password: password },
        headers: { 'content-type': 'application/json' },
      }).then(
        (response) => {
          if (response.data.two_factor_required) {
            that.$store.commit('setTwoFactorMode', response.data.temp_token);
          } else if (response.data.AccessToken) {
            that.$store.commit('setAuthToken', response.data.AccessToken);
            that.$store.commit('setRefreshToken', response.data.RefreshToken);
            that.refreshTokenTimer = setInterval(() => {
              that.refreshToken();
            }, (response.data.ExpiresIn - 60) * 1000);
            that.getLoginInfo(true);
            that.$store.commit('setLoginData', null);
          }
        },
        (error) => {
          that.$store.commit('setLoginData', null);
          const msg = error.response?.data?.message || 'Login failed';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
        }
      );
    },
    refreshToken(isStart) {
      const that = this;
      const token = that.$store.getters.refreshToken;
      axios({
        method: 'post',
        url: `${that.tokenBaseUrl}/Token/Refresh`,
        data: { refreshToken: token },
        headers: { 'content-type': 'application/json' },
      }).then(
        (response) => {
          if (response.data && response.data.AccessToken) {
            if (isStart) {
              if (that.refreshTokenTimer) clearTimeout(that.refreshTokenTimer);
              that.refreshTokenTimer = setInterval(() => {
                that.refreshToken();
              }, (response.data.ExpiresIn - 60) * 1000);
              that.getLoginInfo(false);
            }
            that.$store.commit('setAuthToken', response.data.AccessToken);
            that.$store.commit('setRefreshToken', response.data.RefreshToken);
          } else {
            that.$store.commit('setAuthToken', '');
            clearTimeout(that.refreshTokenTimer);
            that.$router.push({ path: '/login' });
          }
        },
        (error) => {
          console.log('refresh failed', error);
          that.$store.commit('setAuthToken', '');
          clearTimeout(that.refreshTokenTimer);
          that.$router.push({ path: '/login' });
        }
      );
    },
    async getLoginInfo(isRedirectToRootPage) {
      let response = await this.$api.get('/Security/GetLoginInfo');
      if (response && response.data) {
        this.$store.commit('setUserInfo', response.data);
        if (isRedirectToRootPage) this.$router.push({ name: 'MemberSearch', path: '/' });
      }
    },
    async logOut() {
      const that = this;
      if (this.refreshTokenTimer) {
        clearTimeout(that.refreshTokenTimer);
      }
      var token = that.$store.getters.token;
      if (token) {
        await that.$api.post('/Security/SignOut');
      }
      that.$store.commit('setAuthToken', '');
      that.$store.commit('setRefreshToken', '');
    },
    async verifyTfaCode(code) {
      try {
        const that = this;
        const tempToken = that.$store.state.temporaryToken;
        const response = await axios.post(
          `${that.tokenBaseUrl}/Token/TwoFactor`,
          { tempToken: tempToken, code: code },
          { headers: { 'content-type': 'application/json' } }
        );
        if (response.data.AccessToken) {
          that.$store.commit('setAuthToken', response.data.AccessToken);
          that.$store.commit('setRefreshToken', response.data.RefreshToken);
          that.refreshTokenTimer = setInterval(() => {
            that.refreshToken();
          }, (response.data.ExpiresIn - 60) * 1000);
          that.getLoginInfo(true);
          that.$store.commit('setLoginData', null);
          that.$store.commit('setTwoFactorMode', null);
        }
      } catch (err) {
        console.log(err);
        this.$store.commit('setNotificationMessage', { type: 'error', text: 'Two-factor verification failed.' });
      }
    },
  },
};
</script>

<style lang="scss">
html {
  //overflow: auto;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1000px;
}

.v-application--wrap {
  background-color: #e5e5e5;
}

.mainContainer {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 20px;
  padding: 20px;
}

.mainArea {
  width: 100%;
  background-color: white;
  overflow: hidden;
}

.layoutWithSubmenu {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}

.layoutWithSubmenu > * {
  height: 100%;
}

.submenu {
  //width: 56px;
  flex-shrink: 0;
  height: 100%;
}

.contentArea {
  flex: 1;
  overflow: auto;
  margin-top: 5px;
  padding-bottom: 20px;
}

.textInfo {
  font-size: 0.9rem;
  color: rgb(95, 95, 95);
}

a {
  text-decoration: none;
}

tbody tr:nth-child(odd) {
  background-color: #f4f4f4;
}
.v-date-picker-table tbody tr:nth-child(odd) {
  background-color: transparent;
}
.v-data-table__selected {
  background-color: #cbe9ff !important;
  color: #1571cb;
}
table > tbody > tr:hover:not(.v-data-table__empty-wrapper) {
  background-color: #e1e1e1 !important;
}
.v-date-picker-table table > tbody > tr:hover:not(.v-data-table__empty-wrapper) {
  background-color: transparent !important;
}
.v-data-table tbody tr:not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.v-tabs {
  margin-bottom: 10px;

  .v-tabs-slider {
    width: 0px;
  }

  .v-tab {
    border: 1px solid;
    border-radius: 30px;
    color: #4a1cd4 !important;
    height: 35px;
    margin-right: 10px;
    margin-left: 0 !important;

    &.v-tab--active {
      color: white !important;
      background-color: #4a1cd4;
    }
  }
}

.v-footer {
  background: white !important;
  /* padding: 20px 10px; */
}

.fullscreen-view {
  padding: 0;
  background-color: transparent;
  height: 100vh;
}

.fullscreen-router-view {
  height: 100%;
}
</style>
